
import { Vue, Component } from "vue-property-decorator";
import NiceButton from "@/components/UI/NiceButton.vue";

@Component({
  components: { NiceButton }
})
export default class InlineAiNoApiKey extends Vue {}
